import { getTranslations } from 'next-intl/server'

export async function getCities() {
  const t = await getTranslations()

  const cities = [
    {
      name: t('links.berlin'),
      slug: 'berlin',
      image: '/images/city-details/berlin.webp',
      country: t('links.germany'),
    },
    {
      name: t('links.rome'),
      slug: 'rome',
      image: '/images/city-details/rome.webp',
      country: t('links.italy'),
    },
    {
      name: t('links.london'),
      slug: 'london',
      image: '/images/city-details/london.webp',
      country: t('links.unitedKingdom'),
    },
    {
      name: t('links.madrid'),
      slug: 'madrid',
      image: '/images/city-details/madrid.webp',
      country: t('links.spain'),
    },
    {
      name: t('links.paris'),
      slug: 'paris',
      image: '/images/city-details/paris.webp',
      country: t('links.france'),
    },
    {
      name: t('links.vienna'),
      slug: 'vienna',
      image: '/images/city-details/vienna.webp',
      country: t('links.austria'),
    },
    {
      name: t('links.prague'),
      slug: 'prague',
      image: '/images/city-details/prague.webp',
      country: t('links.czechRepublic'),
    },
    {
      name: t('links.amsterdam'),
      slug: 'amsterdam',
      image: '/images/city-details/amsterdam.webp',
      country: t('links.netherlands'),
    },
    {
      name: t('links.lisbon'),
      slug: 'lisbon',
      image: '/images/city-details/lisbon.webp',
      country: t('links.portugal'),
    },
    {
      name: t('links.marseille'),
      slug: 'marseille',
      image: '/images/city-details/marseille.webp',
      country: t('links.france'),
    },
    {
      name: t('links.birmingham'),
      slug: 'birmingham',
      image: '/images/city-details/birmingham.webp',
      country: t('links.unitedKingdom'),
    },
    {
      name: t('links.barcelona'),
      slug: 'barcelona',
      image: '/images/city-details/barcelona.webp',
      country: t('links.spain'),
    },
    {
      name: t('links.doha'),
      slug: 'doha',
      image: '/images/city-details/doha.webp',
      country: t('links.qatar'),
    },
    {
      name: t('links.liverpool'),
      slug: 'liverpool',
      image: '/images/city-details/liverpool.webp',
      country: t('links.unitedKingdom'),
    },
    {
      name: t('links.munich'),
      slug: 'munich',
      image: '/images/city-details/munich.webp',
      country: t('links.germany'),
    },
    {
      name: t('links.edinburgh'),
      slug: 'edinburgh',
      image: '/images/city-details/edinburgh.webp',
      country: t('links.unitedKingdom'),
    },
    {
      name: t('links.frankfurt'),
      slug: 'frankfurt',
      image: '/images/city-details/frankfurt.webp',
      country: t('links.germany'),
    },
  ]

  return cities
}
